import React from 'react';
import { useVisualViewportContainer } from './hooks';
import { Container } from './styles';
import { VisualViewportContainerProps } from './types';

export const VisualViewportContainer: React.FC<VisualViewportContainerProps> = (props) => {
  const { children, className, style } = useVisualViewportContainer(props);
  return (
    <Container className={className} style={style}>
      {children}
    </Container>
  );
};
